import React from "react";
import { Table } from 'antd';

import companiesTableBuilder from "./companies-table-builder";
import { tableHelper } from "utils";


const CompaniesTableRender = ({
    data,
    loading,
    pagination,
    setOrderBy,
    defaultOrder
}) => {

    const { dataSource, columns } = companiesTableBuilder({
        data : !loading && !pagination.total ? [""] : data,
        loading,
        rowAmount : tableHelper.tableRowsCount( pagination ),
        onlyHeader: !loading && !data.length
    });

    return(
        <Table 
            dataSource={ dataSource }
            columns={ columns }  
            pagination={ pagination }
            onChange={ ( pagination, filters, { column, order } ) => {
               
                if( column && order ){
                    
                    setOrderBy([
                        { 
                            column: column.columnIndex, 
                            order: order === "ascend" ? "ASC" : "DESC"  
                        }
                    ])

                } else { setOrderBy( [ defaultOrder ] ) }

            }}
        />
    )

}

export default CompaniesTableRender;